import i18n from '@/i18n'

const baseURL = process.env.VUE_APP_ROOT_API || 'http://localhost:5000'

const getDefinitionApiEndpoint = (api) => {
  const locale = i18n.locale.replace('-', '_')
  return `${baseURL}/definitions/resources/${api}/api-${locale}.yaml`
}

const getDefinitionApiFixedEndpoint = (api) => {
  return `${baseURL}/definitions/resources/${api}/api.yaml`
}

export { getDefinitionApiEndpoint, getDefinitionApiFixedEndpoint }
